import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { Text } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { CHECKOUT_ORDER_SUMMARY_DONATION } from '@fhs-legacy/frontend/src/utils/test-ids';

function DonationRow() {
  const { selectedDonationCartEntry } = useCartContext();

  const donationAmount = useMemo(
    () => selectedDonationCartEntry?.price || 0,
    [selectedDonationCartEntry]
  );

  const showItemDonationRow = donationAmount > 0;
  if (!showItemDonationRow) {
    return null;
  }

  return (
    <View testID={CHECKOUT_ORDER_SUMMARY_DONATION} style={styles.container}>
      <Text.Paragraph size="sm">Donation</Text.Paragraph>
      <Text.Paragraph size="sm">${(donationAmount / 100).toFixed(2)}</Text.Paragraph>
    </View>
  );
}

export default memo(DonationRow);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 4,
    marginHorizontal: 28,
  },

  priceContainer: {
    flexDirection: 'row',
    gap: 9,
    alignItems: 'center',
  },
});
